import * as React from 'react';
import {cs}       from "@Common/react/chain-services";

export const AiToolInteractionTrigger = () => {
    const previousAiInteractionCount = Number(sessionStorage.getItem("aiInteractionCount")) ?? 0;
    const newAiInteractionCount = String(previousAiInteractionCount + 1);
    sessionStorage.setItem("aiInteractionCount", newAiInteractionCount );
};
